import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';

import Table from '../../components/table';
import SearchBar from '../../components/searchBar';
import messages from '../../text/messages';
import { history } from '../../configuration/store';
import { dateToFloatingString } from '../../utilities/dateTime';
import { generatePDFDocument } from '../../reducers/invoices';
import { getDocumentDetails } from '../../reducers/documents';
import { formatMoney } from '../../utilities/string';

class InvoicesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: ''
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.goToDetails = this.goToDetails.bind(this);
    }

    filterResults() {
        const { invoices } = this.props;
        const { searchString } = this.state;

        if (!searchString.trim()) {
            return invoices;
        }

        let filter = searchString.toLowerCase();
        return invoices.filter(e => e.client_name.toLowerCase().includes(filter) || e.name.toLowerCase().includes(filter));
    }

    goToDetails(invoice) {
        history.push(`/invoice/${invoice.id}`);
    }

    getColumnDefinition() {
        const { role } = this.props;
        let showClientColumn = role.type === 'admin';
        const timeSort = (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime();

        let columns = [
            {
                label: <FormattedMessage {...messages.invoiceDate} />,
                valueMap: d => (
                    <div className="full-height-cell clickable" onClick={() => this.goToDetails(d)}>
                        <div className="ellipsis">{dateToFloatingString(d.date, 'YYYY-MM-DD')}</div>
                    </div>
                ),
                size: showClientColumn ? 'col-md-3 col-sm-6 col-xs-6' : 'col-md-4 col-sm-12 col-xs-12',
                sort: timeSort
            },
            {
                label: <FormattedMessage {...messages.invoiceNumber} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.goToDetails(d)}>
                        {d.name}
                    </div>
                ),
                size: showClientColumn ? 'col-md-2 hidden-sm hidden-xs' : 'col-sm-4 hidden-xs',
                sort: (a, b) => a.name.localeCompare(b.name)
            },
            {
                label: <FormattedMessage {...messages.currency} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.goToDetails(d)}>
                        {d.currency}
                    </div>
                ),
                size: 'col-xs-2 hidden-sm hidden-xs',
                sort: (a, b) => a.currency.localeCompare(b.currency)
            },
            {
                label: <FormattedMessage {...messages.amount} />,
                valueMap: d => (
                    <div className="full-height-cell clickable pull-right" onClick={() => this.goToDetails(d)}>
                        {formatMoney(d.total, d.currency)}
                    </div>
                ),
                size: 'col-xs-2 hidden-sm hidden-xs',
                justify: 'right',
                sort: (a, b) => a.total - b.total
            }
        ];

        if (showClientColumn) {
            const clientColumn = {
                label: <FormattedMessage {...messages.client} />,
                valueMap: d => (
                    <div className="full-height-cell clickable" onClick={() => this.goToDetails(d)}>
                        <div className="ellipsis">{d.client_name}</div>
                    </div>
                ),
                size: 'col-md-3 col-sm-6 col-xs-6',
                sort: (a, b) => a.client_name.localeCompare(b.client_name) || timeSort(a, b),
                descSort: (a, b) => b.client_name.localeCompare(a.client_name) || timeSort(a, b)
            };

            return [clientColumn, ...columns];
        }

        return columns;
    }

    render() {
        const filterResults = this.filterResults();

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table data={filterResults || []} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            generatePDFDocument,
            getDocumentDetails
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(InvoicesList);



// WEBPACK FOOTER //
// ./src/pages/invoices/invoicesList.jsx